export const LINKS = {
  SOCIETY_SIX: 'https://society6.com/nayounkim',
}
